import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalProps } from 'shared/lib/components/modals/modal';
import { MobxContext } from 'shared/lib/contexts/mobxContext';
import { FileModel } from 'entities/file/model/fileModel';
import ReplaceFileModal from 'widgets/files/replaceFileModal';
import { UpdateFileHelper } from 'entities/file/model/updateFileHelper';

export default observer(function ReplaceFileModalController({
  fileModel,
  handleClose,
}: {
  fileModel: FileModel;
} & {
  handleClose: ModalProps['handleClose'];
}) {
  const { mobxStore } = useContext(MobxContext);
  const { t } = useTranslation();

  return (
    <ReplaceFileModal
      isOpen={true}
      handleClose={handleClose}
      onSubmit={async (uploadedFile) => {
        if (fileModel.data) {
          try {
            const updateHelper = new UpdateFileHelper(fileModel.data);
            await updateHelper.update({
              id: fileModel.id,
              file: uploadedFile.originalFile,
              name: uploadedFile.originalFile.name,
            });
            await fileModel.fetch({ in_trash: null });
            fileModel.updatePreviewUrlWithCacheBuster();
          } catch (e) {
            console.error(e);
            mobxStore.notificationsStore.errorMessage = t(
              'notifications.errors.default'
            );
          }
        }

        handleClose();
      }}
    ></ReplaceFileModal>
  );
});
